import { render, staticRenderFns } from "./showQuestion.vue?vue&type=template&id=360edff0&scoped=true&"
import script from "./showQuestion.vue?vue&type=script&lang=js&"
export * from "./showQuestion.vue?vue&type=script&lang=js&"
import style0 from "./showQuestion.vue?vue&type=style&index=0&id=360edff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360edff0",
  null
  
)

export default component.exports